// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Node } from "../../../data/app-core/node";
import { NodeRole } from "../../../data/app-core/node-role";
import { EnvelopeDocument } from "../base/envelope-document";

export class NodeDocument extends EnvelopeDocument {
	public override Item: Node = new Node();
	public NodeRoles: NodeRole[] = [];
}